import React, { useState } from 'react'
import {
  useFloating,
  autoUpdate,
  offset as offsetPlacement,
  flip,
  shift,
  useHover,
  useFocus,
  useDismiss,
  useRole,
  useInteractions,
  FloatingPortal,
  safePolygon,
} from '@floating-ui/react'

import * as styles from './tooltip.module.scss'

// https://floating-ui.com/docs/useFloating#placement
// https://codesandbox.io/p/sandbox/cranky-river-ifx8s9?file=%2Fsrc%2FApp.tsx%3A37%2C52
export default function Tooltip({
  children,
  trigger,
  placement = 'bottom',
  role = 'tooltip',
  offset = 10,
  offsetCross = 0,
}) {
  const [isOpen, setIsOpen] = useState(false)

  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: placement,
    // Make sure the tooltip stays on the screen
    whileElementsMounted: autoUpdate,
    middleware: [
      offsetPlacement({
        mainAxis: offset,
        crossAxis: offsetCross,
      }),
      flip({
        fallbackAxisSideDirection: 'start',
      }),
      shift(),
    ],
  })

  // Event listeners to change the open state
  const hover = useHover(context, {
    move: false,
    handleClose: safePolygon({
      // requireIntent: false
    }),
  })
  const focus = useFocus(context)
  const dismiss = useDismiss(context)
  // Role props for screen readers
  const SRRole = useRole(context, { role })

  // Merge all the interactions into prop getters
  const { getReferenceProps, getFloatingProps } = useInteractions([
    hover,
    focus,
    dismiss,
    SRRole,
  ])

  return (
    <>
      {React.cloneElement(trigger, {
        ref: refs.setReference,
        ...getReferenceProps(),
      })}

      <FloatingPortal>
        {isOpen && (
          <div
            className={styles.tooltip}
            ref={refs.setFloating}
            style={floatingStyles}
            {...getFloatingProps()}
          >
            {children}
          </div>
        )}
      </FloatingPortal>
    </>
  )
}
